import buildRevisionOptions from 'app/shared/playbooks/buildRevisionOptions';

/**
 * Convert a list of integrations to a map of revision options by integration ID
 *
 * @param {Array<{id: string, playbooks: Array<{id: string, revision: number, disabledAt: ?string}>}>} integrations
 * @returns {Object<string, Array<{value: string, label: string, disabled: boolean}>>}
 */
export default function buildRevisionOptionsById(integrations) {
  return integrations.reduce((revisionsMap, integration) => {
    // Filter select: disabled revisions stay selectable — filtering by one is how users
    // find the pipelines that need moving off of it.
    revisionsMap[integration.id] = buildRevisionOptions(integration.playbooks, { blockDisabled: false });

    return revisionsMap;
  }, {});
}
